import { required, minLength, maxLength } from "vuelidate/lib/validators";

export const FormEditValidateRule = {
  name: {
    required,
    minLength: minLength(0),
    maxLength: maxLength(255),
  },
};
